import React, { createContext, useContext, useState, useCallback } from 'react';
import VerisafeSnackbar from '../components/VerisafeSnackbar';

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    // useCallback ensures this function doesn't change on every render
    const showSnackbar = useCallback((message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    }, []);

    const hideSnackbar = useCallback(() => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    }, []);

    return (
        <SnackbarContext.Provider value={showSnackbar}>
            {children}
            <VerisafeSnackbar 
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={hideSnackbar}
            />
        </SnackbarContext.Provider>
    );
};

// Custom hook for easy access in components
export const useSnackbar = () => useContext(SnackbarContext);